import { styled } from 'styled-components';
import { StoredAvatar } from '~/gql/avatars/avatars';
import { renderFullPath } from '~/utils/common/utils';
import iconValid from '@assets/images/icon/icon-valid.png';

type IProps = {
  avatar: StoredAvatar;
  onClick: () => void;
  selected?: boolean;
};

type TProps = IProps;

export function AvatarItem({ avatar, onClick, selected }: TProps) {
  return (
    <Container $selected={selected} onClick={onClick}>
      <img src={renderFullPath(avatar.fileName)} alt="" />
      {selected && (
        <SDivSelected>
          <img src={iconValid} alt="" />
        </SDivSelected>
      )}
    </Container>
  );
}

const SDivSelected = styled.div`
  top: -1px;
  right: -1px;
  height: 24px;
  width: 24px;
  position: absolute;
  img {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    object-fit: contain;
    position: absolute;
  }
`;
const Container = styled.div<{ $selected?: boolean }>`
  border-radius: 19.2px;
  border: ${({ $selected }) =>
    $selected ? '3px solid #EA7A49' : '2px solid #FFF'};
  background: ${({ $selected }) =>
    $selected ? 'rgba(255, 255, 255, 0.70)' : 'rgba(215, 215, 215, 0.50)'};
  box-shadow: ${({ $selected }) =>
    $selected
      ? '0px 1px 3px 0px rgba(0, 0, 0, 0.25), 0px -4px 4px 0px rgba(0, 0, 0, 0.25) inset'
      : 'none'};
  margin: 5px;
  position: relative;
  height: 100px;
  overflow: hidden;

  @media screen and (max-width: 450px) {
    height: 80px;
  }
  @media screen and (max-height: 450px) {
    height: 70px;
  }

  img {
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`;
